import React from "react";
import { AgnesCollapsible, AgnesCollapsibleContent, AgnesCollapsibleTrigger, cn } from "@agnes/ui";
import { ChevronDown, ChevronUp } from "lucide-react";
import { BaseComponentProps } from "@/components/BaseComponentProps";

export interface SecaoRecolhivelProps extends BaseComponentProps {
  titulo: string;
  icone: React.ReactNode;
  /** Selo à direita do título (ex.: "Automático"). */
  selo?: React.ReactNode;
  abertaInicialmente?: boolean;
  rotuloAberta?: string;
  rotuloFechada?: string;
}

export function SecaoRecolhivel({
  titulo,
  icone,
  selo,
  abertaInicialmente = true,
  rotuloAberta = "Ocultar",
  rotuloFechada = "Mostrar",
  className,
  children,
  dataQa,
}: SecaoRecolhivelProps) {
  const [aberta, setAberta] = React.useState(abertaInicialmente);
  return (
    <AgnesCollapsible
      dataQa={dataQa}
      open={aberta}
      onOpenChange={setAberta}
      className={cn("rounded-xl border border-agnes-border bg-agnes-bg-default", className)}
    >
      <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-4">
        <h3 className="flex items-center gap-2 font-semibold text-agnes-primary">
          {icone}
          {titulo}
        </h3>
        <div className="flex items-center gap-3">
          {selo}
          <AgnesCollapsibleTrigger
            dataQa={dataQa}
            aria-label={`${aberta ? rotuloAberta : rotuloFechada} ${titulo}`}
            className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm font-semibold text-agnes-text-primary hover:bg-[rgba(68,45,150,0.05)]"
          >
            {aberta ? rotuloAberta : rotuloFechada}
            {aberta ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
          </AgnesCollapsibleTrigger>
        </div>
      </div>
      <AgnesCollapsibleContent dataQa={dataQa} className="border-t border-agnes-border">
        {children}
      </AgnesCollapsibleContent>
    </AgnesCollapsible>
  );
}
